import React, { useEffect, useState } from "react";
import "./Style.css";
import Loader from "../../Component/Loader/Loader";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { userServiceUrl } from "../Config/config";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { displayError, getSurveyDetails, showToast } from "../Utils/utils";
import { connect } from "react-redux";

const SurveyOne = () => {
  const navigate = useNavigate()
  const [name, setName] = useState("");
  const [age, setAge] = useState("");
  const [gender, setGender] = useState("");
  const [genderArr, setGenderArr] = useState([
    { label: "Male", value: "male" },
    { label: "Female", value: "female" },
    { label: "Non Binary", value: "no-binary" },
  ]);
  const [occupation, setOccupation] = useState("");
  const [contact, setContact] = useState("");
  const [email, setEmail] = useState("");
  const [feet, setFeet] = useState("");
  const [feetArr, setFeetArr] = useState([
    { value: 1, label: "1 Feet" },
    { value: 2, label: "2 Feet" },
    { value: 3, label: "3 Feet" },
    { value: 4, label: "4 Feet" },
    { value: 5, label: "5 Feet" },
    { value: 6, label: "6 Feet" },
    { value: 7, label: "7 Feet" },
    { value: 8, label: "8 Feet" },
    { value: 9, label: "9 Feet" },
  ]);
  const [inch, setInch] = useState("");
  const [inchArr, setInchArr] = useState([
    { value: 0, label: "0 Inch" },
    { value: 1, label: "1 Inch" },
    { value: 2, label: "2 Inch" },
    { value: 3, label: "3 Inch" },
    { value: 4, label: "4 Inch" },
    { value: 5, label: "5 Inch" },
    { value: 6, label: "6 Inch" },
    { value: 7, label: "7 Inch" },
    { value: 8, label: "8 Inch" },
    { value: 9, label: "9 Inch" },
    { value: 10, label: "10 Inch" },
    { value: 11, label: "11 Inch" },
    { value: 12, label: "12 Inch" },
  ]);
  const [weight, setWeight] = useState("");
  const [bmi, setBMI] = useState("");
  const [complaints, setComplaints] = useState("");
  const [date, setDate] = useState(new Date());
  const [treatment, setTreatment] = useState("");
  const [mCondition, setMCondition] = useState("");
  const [allergies, setAllergies] = useState("");
  const [surgeries, setSurgeries] = useState("");
  const [pain, setPain] = useState('');
  const [loading, setLoading] = useState(false);
  let location = useLocation();
  let id = new URLSearchParams(location.search).get('id')
  let isEdit = new URLSearchParams(location.search).get('edit')


  const painLevels = [
    { label: "No Pain", emoji: "/Images/nopain.png", value: "No-Pain" },
    { label: "Mild", emoji: "/Images/mildpain.png", value: "Mild-Pain" },
    {
      label: "Moderate",
      emoji: "/Images/moderatepain.png",
      value: "Moderate-Pain",
    },
    { label: "Severe", emoji: "/Images/severepain.png", value: "Severe-Pain" },
    {
      label: "Very Severe",
      emoji: "/Images/veryseverepain.png",
      value: "Very-Severe-Pain",
    },
    {
      label: "Worst Pain",
      emoji: "/Images/worstpain.png",
      value: "Worst-Pain",
    },
  ];

  const AddSurvey = async () => {
    try {
      const data = {
        name: name,
        age: parseInt(age),
        gender: gender,
        phone_number: contact,
        email: email,
        occupation: occupation,
        height_foot: parseInt(feet),
        height_inch: parseInt(inch),
        weight: parseInt(weight),
        bmi: parseInt(bmi),
        // symptoms_start_date: date,
        symptoms: complaints,
        ongoing_treatment: treatment,
        medical_conditions_before: mCondition,
        medication_or_allergies: allergies,
        past_surgeries: surgeries,
        pain_level: pain
      }
      let token = localStorage.getItem("token")
      const response = await axios.post(
        `${userServiceUrl}/provider/add-survey`,
        data,
        {
          headers: {
            "Content-Type": "application/json", Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status == 200) {
        showToast(response.data.message, "success")
        setTimeout(() =>
          navigate(`/surveysteptwo?survey_id=${response.data?.data?._id}`)
          , 2000)
      }
    } catch (error) {
      // displayError(error)
      // console.error(error.response.data);
      showToast(error.response.data.message, "error");
      // throw error.response ? error.response.data : error;
    }
  }
  const updateSurvey = async () => {
    try {
      const data = {
        name: name,
        age: parseInt(age),
        gender: gender,
        phone_number: contact,
        email: email,
        occupation: occupation,
        height_foot: parseInt(feet),
        height_inch: parseInt(inch),
        weight: parseInt(weight),
        bmi: parseInt(bmi),
        // symptoms_start_date: date,
        symptoms: complaints,
        ongoing_treatment: treatment,
        medical_conditions_before: mCondition,
        medication_or_allergies: allergies,
        past_surgeries: surgeries,
        pain_level: pain
      }
      let token = localStorage.getItem("token")
      const response = await axios.post(
        `${userServiceUrl}/provider/update-survey-details/${id}`,
        data,
        {
          headers: {
            "Content-Type": "application/json", Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status == 200) {
        showToast(response.data.message, "success")
        setTimeout(() =>
          navigate(`/surveysteptwo?survey_id=${response.data?.data?._id}&edit=true`)
          , 2000)
      }
    } catch (error) {
      // displayError(error)
      // console.error(error.response.data);
      showToast(error.response.data.message, "error");
      // throw error.response ? error.response.data : error;
    }
  }


  const getSurveyDetail = async () => {
    var res = await getSurveyDetails(id)
    setName(res.data?.name ? res.data?.name : res.data?.full_name)
    setAge(res.data?.age)
    setGender(res.data?.gender)
    setContact(res.data?.phone_number)
    setOccupation(res.data?.occupation)
    setEmail(res.data?.email)
    setFeet(res.data?.height_foot)
    setInch(res.data?.height_inch)
    setWeight(res.data?.weight)
    setBMI(res.data?.bmi)
    setComplaints(res.data?.symptoms)
    setTreatment(res.data?.ongoing_treatment)
    setMCondition(res.data?.medical_conditions_before)
    setAllergies(res.data?.medication_or_allergies)
    setSurgeries(res.data?.past_surgeries)
    setPain(res.data?.pain_level)
  }

  useEffect(() => {
    if (isEdit === 'true') {
      getSurveyDetail()
    }
  }, [isEdit])
  return (
    <>
      {loading && <Loader />}
      <div className="page-top">
        <div className='booking-top-container px-4 py-3'>
          <Link to="/survey-dashboard" style={{ textDecoration: 'none' }}>
            <img
              className="img-fluid left-arrow-img"
              src="./Images/left-arrow.svg"
              alt="arrow"
            />
          </Link>

        </div>
        <div className="page-wrapper mx-auto px-4">
          {/* Start Survey */}
          <div className="">
            <div className="d-flex justify-content-between">
              {isEdit == 'true' ?
                <h3 className="provider-title">Edit Survey</h3>
                :
                <h3 className="provider-title">Start Survey</h3>
              }
              <img
                className="img-fluid"
                src="/Images/logo.svg"
                alt="logo image"
              />
            </div>

            <h6 className="login-title mt-2">Basic Details</h6>
          </div>

          {/* Name */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">Patient Name</label>
            <input
              className="emailinput"
              type="text"
              onChange={(e) => setName(e.target.value)}
              value={name}
              placeholder="Enter name"
            />
          </div>

          {/* Age */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">Patient Age</label>
            <input
              className="emailinput"
              type="text"
              onChange={(e) => setAge(e.target.value)}
              value={age}
              placeholder="Enter age"
            />
          </div>

          {/* Gender */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">Patient Gender</label>
            <select
              className="emailinput gender-input"
              onChange={(e) => setGender(e.target.value)}
              value={gender}
            >
              <option className="gender-input" value={""}>
                Select gender
              </option>

              {genderArr.map((a) => (
                <option className="gender-input" value={a.value}>
                  {a.label}
                </option>
              ))}
            </select>
          </div>

          {/* Occupation */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">Patient Occupation</label>
            <input
              className="emailinput"
              type="text"
              onChange={(e) => setOccupation(e.target.value)}
              value={occupation}
              placeholder="Enter Occupation"
            />
          </div>

          {/* Contact Number */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">Patient Contact Number</label>
            <PhoneInput
              className="survey-phone"
              country={"in"}
              onlyCountries={["in"]}
              value={contact}
              onChange={(phone) => setContact(phone)}
              placeholder="Enter mobile number"
            />
          </div>

          {/* Email ID */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">Email Address (If any)</label>
            <input
              className="emailinput"
              type="text"
              onChange={(e) => setEmail(e.target.value)}
              value={email}
              placeholder="Enter email address"
            />
          </div>

          {/* Height */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">Patient Height</label>
            <div className="row">
              {/* Feet Drop */}
              <div className="col-6">
                <select
                  className="emailinput gender-input w-100"
                  onChange={(e) => setFeet(e.target.value)}
                  value={feet}
                >
                  <option className="gender-input" value={""}>
                    Select Feet
                  </option>

                  {feetArr.map((a) => (
                    <option className="gender-input" value={a.value}>
                      {a.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* Inch Drop */}
              <div className="col-6">
                <select
                  className="emailinput gender-input w-100"
                  onChange={(e) => setInch(e.target.value)}
                  value={inch}
                >
                  <option className="gender-input" value={""}>
                    Select Inches
                  </option>

                  {inchArr.map((a) => (
                    <option className="gender-input" value={a.value}>
                      {a.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {/* Weight */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">Patient Weight</label>
            <input
              className="emailinput"
              type="text"
              onChange={(e) => setWeight(e.target.value)}
              value={weight}
              placeholder="Enter in Kgs"
            />
          </div>

          {/* BMI */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">Patient BMI</label>
            <input
              className="emailinput"
              type="text"
              onChange={(e) => setBMI(e.target.value)}
              value={bmi}
              placeholder="Enter BMI"
            />
          </div>

          <h6 className="login-title mt-3 margin-btm">Health History</h6>

          {/* Complaints */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">
              What are the chief complaints?
            </label>
            <input
              className="emailinput"
              type="text"
              onChange={(e) => setComplaints(e.target.value)}
              value={complaints}
              placeholder="Enter chief complaints"
            />
          </div>

          {/* Symptoms Date */}
          {/* <div className="email d-flex flex-column gap-2 margin-btm">
            <div className="email d-flex flex-column gap-2">
              <label className="email-label">
                When did the symptoms start?
              </label>
              <div className="survey-phone">
                <DatePicker
                  className="survey-phone"
                  selected={date}
                  dateFormat="yyyy-MM-dd"
                  onChange={(date) => setDate(date)}
                  maxDate={new Date()}
                  customInput={
                    <input
                      type="text"
                      className="form-control"
                      placeholder={"Date"}
                      value={date}
                    />
                  }
                />
                <img src="/Images/calendar.png" className="cal-icon" />
              </div>
            </div>
          </div> */}

          {/* Ongoing Treatments */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">Ongoing treatments?</label>
            <input
              className="emailinput"
              type="text"
              onChange={(e) => setTreatment(e.target.value)}
              value={treatment}
              placeholder="Enter ongoing treatments"
            />
          </div>

          {/* Medical Conditions */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">
              Any medical conditions before?
            </label>
            <input
              className="emailinput"
              type="text"
              onChange={(e) => setMCondition(e.target.value)}
              value={mCondition}
              placeholder="Enter previous medical condition"
            />
          </div>

          {/* Allergies */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">
              Any current medications or drug allergies?
            </label>
            <input
              className="emailinput"
              type="text"
              onChange={(e) => setAllergies(e.target.value)}
              value={allergies}
              placeholder="Enter current medications or drug allergies"
            />
          </div>

          {/* Surgeries */}
          <div className="email d-flex flex-column gap-2 margin-btm">
            <label className="email-label">
              Any past surgeries or procedures?
            </label>
            <input
              className="emailinput"
              type="text"
              onChange={(e) => setSurgeries(e.target.value)}
              value={surgeries}
              placeholder="Enter past surgeries or procedures"
            />
          </div>

          {/* Pain Level */}
          <div className="email d-flex flex-column gap-2">
            <label className="email-label margin-btm">Pain Level</label>

            <div className="flex flex-col items-center shadow-md">
              <div
                className="row"
                style={{ justifyContent: "space-between" }}
              >
                {painLevels.map((level, index) => (
                  <div
                    key={index}
                    className={`w-auto pe-0 items-center text-sm  
                        ${pain == '' ? 'no-select-box' : level.value == pain ? "select-box" : "un-select-box"
                      }`}
                    onClick={() => setPain(level.value)}
                  >
                    <div
                      className={"text-2xl"}
                      style={{ textAlign: "center", cursor: "pointer" }}
                    >
                      <img src={level.emoji} className="pain-slide" />
                      {/* {level.emoji} */}
                    </div>

                    <div className="emoji-name">{level.label}</div>
                  </div>
                ))}
              </div>

              <div>
                <img src={"/Images/black-line.png"} className="level-line" />
              </div>

              <div
                className="row"
                style={{ justifyContent: "space-between" }}
              >
                {[...Array(10)].map((_, index) => (
                  <div className="w-auto level-scroll">{index + 1}</div>
                ))}
              </div>
            </div>
          </div>

          <div>
            {isEdit === 'true' ?
              <button
                className="continue-btn-res mt-2 padding-50"
                type="submit"
                onClick={updateSurvey}
              >
                <span className="continuebtn-text">Update</span>
              </button>
              :
              <button
                className="continue-btn-res mt-2 padding-50"
                type="submit"
                onClick={AddSurvey}
              >
                <span className="continuebtn-text">Continue</span>
              </button>
            }
          </div>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {};
const mapStateToProps = (state) => {
  return {
    userdata: state.userSession?.sessionData,
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(SurveyOne);

